/* globals grecaptcha */
const key = '6LcE4c8UAAAAAOPPvElrxAmvd4lj-jSNU8hMkkvN';

/**
 * Inset key
 * @param {HTMLElement} wrap
 * @param {String} name
 * @param {String} token
 * @returns {Promise<void>}
 */
async function insertVal(wrap, name, token) {
    const input = wrap.querySelector(`input[name=${name}]`);

    if (input) {
        input.value = token;
    }
}

/**
 * Google recaptcha 3
 * @param {HTMLElement} wrap
 * @param {String} [name]
 */
export default async function recaptchaInit(wrap, name = 'recaptchaToken') {
    if (typeof grecaptcha === 'undefined') {
        throw new SyntaxError('Recaptcha widget not found!');
    }

    await new Promise((resolve) => {
        grecaptcha.ready(async () => {
            const token = await grecaptcha.execute(key, {action: 'homepage'});
            await insertVal(wrap, name, token);
            resolve();
        });
    });
}
